<template>
  <v-card>
    <v-card-title>
      Manually Enabled CS
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <v-autocomplete
            label="Park"
            :items="parks"
            v-model="selectedParkId"
            item-title="name"
            item-value="id"
            :loading="parkLoading? 'primary' : false"
          />
          <v-card variant="outlined" v-if="selectedPark !== null">
            <v-card-text>
              <v-item-group multiple v-model="selectedBnums" @update:model-value="saveParkCS">
                <v-container>
                  <v-row
                    class="mb-2"
                    no-gutters
                    v-for="cs in selectedPark['chargingstations'].sort((a, b) => objComparatorNumber(a, b, 'park_bnum'))">
                    <v-col>
                      <v-item v-slot="{ isSelected, toggle }" :value="cs['bnum']">
                        <v-card
                          elevation="4"
                          :color="isSelected ? 'primary' : ''"
                          class="d-flex align-center"
                          dark
                          @click="toggle"
                        >
                          <div class="text-body-1 flex-grow-1 text-center ma-1">
                            CP {{ cs['park_bnum'] }} - QR {{ cs['qrcodeid'] }} - BNUM {{ cs['bnum'] }}
                          </div>
                        </v-card>
                      </v-item>
                    </v-col>
                  </v-row>
                </v-container>
              </v-item-group>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col>
          Selected Bnums:<br/>
          {{ model.join(', ') }}
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { ref, watch } from 'vue';
import { objComparatorNumber } from "@/utils.js";
import { fetchParkById } from "@/remote/park.js";

const props = defineProps({
  parks: {
    type: Array,
    default: []
  },
  density: {
    type: String,
    default: "default"
  }
});

const model = defineModel({ type: Array, default: [] });

const selectedParkId = ref(null);
const selectedPark = ref(null);
const parkLoading = ref(false);
const selectedBnums = ref([]);

watch(selectedParkId, async (newValue) => {
  if (newValue !== null) {
    parkLoading.value = true;
    selectedPark.value = await fetchParkById(newValue);
    console.log(selectedPark.value);
    loadPark();
    parkLoading.value = false;
  }
});

function saveParkCS() {
  const allBnums = selectedPark.value['chargingstations'].map(el => el['bnum']);
  // noinspection JSUnresolvedReference
  const toRemove = allBnums.filter(item => !selectedBnums.value.includes(item));
  const toAdd = selectedBnums.value.filter(item => !model.value.includes(item));
  model.value = [...model.value.filter(item => !toRemove.includes(item)), ...toAdd];
}

function loadPark() {
  const allBnums = selectedPark.value['chargingstations'].map(el => el['bnum']);
  // noinspection JSValidateTypes
  selectedBnums.value = allBnums.filter(item => model.value.includes(item));
}

</script>

<style scoped>

</style>
